import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Box, useTheme } from '@mui/material';
import ShowModelLineageModal from '../../../components/ModelInventory/ModelRequest/ShowModelLineageModal';

const LinkedEntitiesCell = ({ value, row, entityType }) => {
  const theme = useTheme();
  const [lineageModalOpen, setLineageModalOpen] = useState(false);
  const [selectedLineageItem, setSelectedLineageItem] = useState(null);

  const handleLinkedEntitiesClick = useCallback(
    (rowItem) => {
      setSelectedLineageItem({
        item: { id: rowItem?.original?.unique_id },
        title: 'Linked Entities',
      });
      setLineageModalOpen(true);
    },
    [setSelectedLineageItem, setLineageModalOpen]
  );

  const handleCloseLineageModal = useCallback(() => {
    setLineageModalOpen(false);
  }, [setLineageModalOpen]);

  const handleClick = useCallback(
    (e) => {
      e.stopPropagation();
      handleLinkedEntitiesClick(row);
    },
    [handleLinkedEntitiesClick, row]
  );

  if (value === null || value === undefined) {
    return '-';
  }

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        height="100%"
        onClick={handleClick}
        sx={{ cursor: 'pointer' }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '24px',
            width: 'fit-content',
            height: '24px',
            borderRadius: '12px',
            border: '1px solid',
            borderColor: theme.palette.primary.main,
            color: theme.palette.primary.main,
            fontSize: '12px',
            padding: '0 6px',
          }}
        >
          {value}
        </Box>
      </Box>
      {lineageModalOpen && (
        <ShowModelLineageModal
          open={lineageModalOpen}
          handleClose={handleCloseLineageModal}
          previewItem={selectedLineageItem}
          entityType={entityType}
          openInNewTab={true}
        />
      )}
    </>
  );
};

LinkedEntitiesCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  row: PropTypes.shape({
    original: PropTypes.shape({
      unique_id: PropTypes.string,
    }),
  }),
  entityType: PropTypes.string,
};

export default LinkedEntitiesCell;
